<template>
  <div id="app">
    <loading :isShow="showOrNot" />
    <page-kv :isShow="showOrNot" @startAni="handleStartAni" />
    <page-one :bState="backState" :isShow="showOrNot" :aniStart="startAnimation" @hvDirective="hvPlay" @changeMusic="handleChangeMusic" @selectSex="handleSex" />
    <page-two :isShow="showOrNot" :subselectsex="selectsex" @gogame="entergame" />
    <page-three :isShow="showOrNot" :subselectsex="selectsex" :msubdata="subdata" @backAgain="handleBack" />
    <music-player :isShow="showOrNot" :mState="musicState" />
    <rotate-it />
    <audio :src="m001URL" id="m01" preload="preload"></audio>
    <audio :src="m002URL" id="m02" preload="preload"></audio>
    <audio :src="m003URL" id="m03" preload="preload"></audio>
    <audio :src="m004URL" id="m04" preload="preload"></audio>
    <audio :src="m005URL" id="m05" preload="preload"></audio>
    <audio :src="m006URL" id="m06" preload="preload"></audio>
    <audio :src="m007URL" id="m07" preload="preload"></audio>
    <audio :src="m008URL" id="m08" preload="preload"></audio>
    <audio :src="m009URL" id="m09" preload="preload"></audio>
    <audio :src="m010URL" id="m10" preload="preload"></audio>
    <audio :src="m011URL" id="m11" preload="preload"></audio>
  </div>
</template>

<script>
import Loading from './components/loading/loading'
import Rotate from './components/rotate/Rotate'
import MusicPlayer from './components/musicplayer/music-player'
import PageKV from './components/page-kv/pageKV'
import PageOne from './components/page-one/pageOne'
import PageTwo from './components/page-two/pageTwo'
import PageThree from './components/page-three/pageThree'

export default {
  name: 'app',
  components: {
    Loading,
    'rotate-it': Rotate,
    'music-player': MusicPlayer,
    'page-one': PageOne,
    'page-two': PageTwo,
    'page-three': PageThree,
    'page-kv': PageKV
  },
  data () {
    return {
      showOrNot: {
        isLDShow: true,
        isKVShow: false,
        isPOShow: false,
        isPTShow: false,
        isPRShow: false
      },
      startAnimation: false,
      musicState: false,
      m001URL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/f-squeeze.mp3',
      m002URL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/m-offWork.mp3',
      m003URL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/f-transition2.mp3',
      m004URL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/m-running.mp3',
      m005URL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/m-running2.mp3',
      m006URL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/m-milk.mp3',
      m007URL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/f-dog.mp3',
      m008URL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/f-market.mp3',
      m009URL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/f-buy.mp3',
      m010URL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/subway.mp3',
      m011URL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/keyboard.mp3',
      selectsex:'0', //0男 ；1女
      subdata:{
        name:'',
        city:'',
        zhufu1:'',
        zhufu2: ''
      },
      backState: false
    }
  },
  methods: {
    entergame(data){
      this.subdata=data
    },
    handleStartAni () {
      this.startAnimation = true
    },
    _initMusic (id) {
      let audio = document.getElementById(id)
      // audio.volume = 0
      audio.play()
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.play()
      }, false)

      setTimeout(() => {
        audio.pause()
        document.addEventListener('WeixinJSBridgeReady', function () {
          audio.pause()
        }, false)
      }, 200)
    },
    _initAllMusic () {
      for (let i = 1; i < 10; i++) {
        let myId = `m0${i}`
        this._initMusic(myId)
      }
    },
    _audioPause (id) {
      let audio = document.getElementById(id)
      audio.pause()
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.pause()
      }, false)
    },
    _muteAllMusic () {
      for (let i = 1; i < 12; i++) {
        let myId = i < 10 ? `m00${i}` : `m0${i}`
        this._audioPause(myId)
      }
    },
    hvPlay (data) {
      let musicName = data.name
      let audio = document.getElementById(musicName)
      audio.play()
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.play()
      }, false)
    },
    handleChangeMusic () {
      this.musicState = true
    },
    handleSex (msg) {
      this.selectsex = msg
    },
    handleBack () {
      this.backState = !this.backState
    }
  },
  mounted () {
    this._initAllMusic()
  }
}
</script>

<style lang="less">
@import './assets/reset.less';
#app {
  position: fixed;
  width: 100%;
  height: 100%;
}

#myP {
  width: 100%;
  canvas {
    width: 100%;
  }
}
</style>
